import {initialState} from "./state";

export const tests = (state = initialState, action) => {
    switch (action.type) {
        case "SET_TESTS_LIST": {
            return {
                ...state,
                list: action.data?.data?.tests,
            }
        }
        default:
            return state;
    }
};
